export const { DEV, PROD, MODE, SSR } = import.meta.env;

const BACKEND_DEV_HTTP = window.location.hostname + ":3011";
const PUBLIC_HTTP = "belotmasters.com";

// Optional overrides let a dev session use a remote backend without changing
// the production endpoints or the default local development setup.
export const BACKEND_HTTP = DEV
    ? (import.meta.env.VITE_BACKEND_HTTP || "http://" + BACKEND_DEV_HTTP)
    : "https://" + PUBLIC_HTTP;
export const BACKEND_URI = new URL(BACKEND_HTTP).host;
export const BACKEND_WS = DEV
    ? (import.meta.env.VITE_BACKEND_WS || "ws://" + BACKEND_DEV_HTTP)
    : "wss://" + PUBLIC_HTTP + "/api";
export const PUBLIC_FILES_BASE = window.location.origin;

/**
 * What build this is, for "did the deploy actually reach me?". `builtAt` is the
 * only part always present: the image build has no git repository to ask.
 */
export const BUILD = {
	version: NPM_APP_VERSION,
	commit: GIT_COMMIT_HASH,
	branch: GIT_BRANCH_NAME,
	committedAt: GIT_LAST_COMMIT_TIME,
	builtAt: BUILD_TIME
};

/** One line, shortest form that still identifies the build. */
export function buildLabel(): string {
	const built = new Date(BUILD.builtAt);
	const stamp = Number.isNaN(built.getTime())
		? BUILD.builtAt
		: built.toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
	return [`v${BUILD.version}`, BUILD.commit, stamp].filter(Boolean).join(" · ");
}
